import { type HttpPatch, mapServerError } from '@/shared/infra/http'
import type {
  NotificationPreferences,
  OrgType,
  UpdateNotificationPreferences,
} from '@/shared/domain'

type UpdateNotificationPreferencesBody = {
  orgId: string
  orgType: OrgType
  scheduling?: boolean
  connectMessage?: boolean
  connectMention?: boolean
  connectDigest?: boolean
}

type NotificationPreferencesResponse = { preferences: NotificationPreferences }

export class SupabaseUpdateNotificationPreferencesRepository {
  constructor(private readonly http: HttpPatch) {}

  execute: UpdateNotificationPreferences = async ({
    orgId,
    orgType,
    scheduling,
    connectMessage,
    connectMention,
    connectDigest,
  }) => {
    const body: UpdateNotificationPreferencesBody = {
      orgId,
      orgType,
      ...(scheduling !== undefined ? { scheduling } : {}),
      ...(connectMessage !== undefined ? { connectMessage } : {}),
      ...(connectMention !== undefined ? { connectMention } : {}),
      ...(connectDigest !== undefined ? { connectDigest } : {}),
    }

    try {
      const response = await this.http.patch<
        UpdateNotificationPreferencesBody,
        NotificationPreferencesResponse
      >({
        url: '/users/notification-preferences',
        body,
      })
      return { preferences: response.preferences }
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
